export const ERoles = Object.freeze({
  ADMIN: "ADMIN",
  VERZEL: "VERZEL",
  COMPANY: "COMPANY",
});
